import React from 'react';
import styles from '../../styles/portfolio/tech_icon.scss';


export const IconTextContainer = props => {
    return (
        <div className={resolveClassName(props.isOption, props.disabled, props.extraStyle)} onClick={props.onClick}>
            {props.IconComp ? <props.IconComp className={styles.icon} url={props.url}/> : undefined}
            <div className={props.isOption ? styles.optionText : styles.text}>{props.text}</div>
        </div>
    )

    function resolveClassName(isOption, optionIsDisabled, extraStyle) {
        let returnValue = props.isOption ? getStylesForContainer(optionIsDisabled) : styles.container;

        if (extraStyle) {
            returnValue = returnValue + ' ' + extraStyle;
        }

        return returnValue;
    }

    function getStylesForContainer(optionIsDisabled) {
        return optionIsDisabled ? styles.containerOption + " " + styles.disabledOption: styles.containerOption;
    }
};
